/**
 * Platform currency registry (M8).
 */
export const PLATFORM_FALLBACK_CURRENCY = "COP";

export const CURRENCY_REGISTRY = {
  COP: {
    label: "Colombian Peso",
    symbol: "$",
    country: "CO",
    decimals: 0,
    intlFormatLocale: "es-CO",
    prefix: "COP $",
  },
  USD: {
    label: "US Dollar",
    symbol: "US$",
    country: "US",
    decimals: 0,
    intlFormatLocale: "en-US",
    prefix: "US$",
  },
  EUR: {
    label: "Euro",
    symbol: "€",
    country: "EU",
    decimals: 0,
    intlFormatLocale: "de-DE",
    prefix: "€",
  },
  MXN: {
    label: "Mexican Peso",
    symbol: "MX$",
    country: "MX",
    decimals: 0,
    intlFormatLocale: "es-MX",
    prefix: "MX$",
  },
  BRL: {
    label: "Brazilian Real",
    symbol: "R$",
    country: "BR",
    decimals: 0,
    intlFormatLocale: "pt-BR",
    prefix: "R$",
  },
  RUB: {
    label: "Russian Ruble",
    symbol: "₽",
    country: "RU",
    decimals: 0,
    intlFormatLocale: "ru-RU",
    prefix: "₽",
  },
};

export const REGISTRY_CURRENCIES = Object.keys(CURRENCY_REGISTRY);

export function isRegistryCurrency(currency) {
  return REGISTRY_CURRENCIES.includes(currency);
}

export function getCurrencyMetadata(currency) {
  const normalized = normalizeRegistryCurrency(currency);
  return CURRENCY_REGISTRY[normalized] || CURRENCY_REGISTRY[PLATFORM_FALLBACK_CURRENCY];
}

export function normalizeRegistryCurrency(value) {
  if (value == null || value === "") {
    return PLATFORM_FALLBACK_CURRENCY;
  }
  const upper = String(value).trim().toUpperCase();
  return REGISTRY_CURRENCIES.includes(upper) ? upper : PLATFORM_FALLBACK_CURRENCY;
}
